import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "@/app/App";
import { initBrowserSentry } from "@/lib/sentry";
import "@/styles/index.css";

initBrowserSentry();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
